var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('Header',{staticClass:"headers-roof"}),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.$route.meta.isFooter == 1)?_c('Footer'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }